import "./App.css";
import React, { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { emailjsConfig, isRecaptchaConfigured } from "./config/emailjs";
import { getLayoutFromHost } from "./config/site";

const DiscordApp = lazy(() => import("./layouts/DiscordApp/DiscordApp"));
const MainApp = lazy(() => import("./layouts/MainApp/MainApp"));
const AwsApp = lazy(() => import("./layouts/AwsApp/AwsApp"));
const RiotApp = lazy(() => import("./layouts/RiotApp/RiotApp"));

const LOADER_COLORS = {
  discord: { bg: "var(--background-primary, #36393f)", dot: "#5865F2" },
  aws: { bg: "#0f1419", dot: "#FF9900" },
  riot: { bg: "#010a13", dot: "#d13639" },
  main: { bg: "#080809", dot: "#e8a849" },
};

function AppLoading() {
  const layout = getLayoutFromHost();
  const colors = LOADER_COLORS[layout] || LOADER_COLORS.main;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: colors.bg,
      }}
      aria-live="polite"
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: colors.dot,
          animation: "main-pulse 1.2s ease infinite",
        }}
      />
    </div>
  );
}

function AppShell() {
  const layout = getLayoutFromHost();

  return (
    <Suspense fallback={<AppLoading />}>
      {layout === "discord" && <DiscordApp />}
      {layout === "aws" && <AwsApp />}
      {layout === "riot" && <RiotApp />}
      {layout === "main" && <MainApp />}
    </Suspense>
  );
}

function App() {
  const appContent = (
    <HelmetProvider>
      <AppShell />
    </HelmetProvider>
  );

  if (getLayoutFromHost() === "discord" && isRecaptchaConfigured()) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={emailjsConfig.recaptchaSiteKey}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}
      >
        {appContent}
      </GoogleReCaptchaProvider>
    );
  }

  return appContent;
}

export default App;
